import { render, staticRenderFns } from "./CloudClassroom.vue?vue&type=template&id=1066bd67&scoped=true&"
import script from "./CloudClassroom.vue?vue&type=script&lang=js&"
export * from "./CloudClassroom.vue?vue&type=script&lang=js&"
import style0 from "./CloudClassroom.vue?vue&type=style&index=0&id=1066bd67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1066bd67",
  null
  
)

export default component.exports